import React from 'react'
import FontFaceObserver from 'font-face-observer' // github.com/cymen/font-face-observer
import * as govxStorage from '../localStorage/govxStorage'

export function loadFontFaceObserver() {
	if (!govxStorage.getFontsLoaded()) {
		Promise.all([
			new FontFaceObserver('Roboto Regular').check(),
			new FontFaceObserver('Roboto Medium').check(),
			new FontFaceObserver('Roboto Bold').check()

		])
			.then(() => {
				document.body.classList.add('fonts-loaded')
				govxStorage.setFontsLoaded()
			})
			.catch(err => {
			})
	} else {
		document.body.classList.add('fonts-loaded')
	}
}